<template>
  <el-dialog :title="title" :visible="visible" :data="data" :close-on-click-modal="false" :modal="false" @close="$emit('update:visible', false)">
    <el-table
      ref="pipelineDetailTable"
      key="pipelineDetail"
      :data="data"
      size="mini"
      max-height="400"
      style="width: 100%"
    >
      <el-table-column label="姓名">
        <template slot-scope="scope">
          <a v-if="'职能模块' in scope.row" @click="showRadish(scope.row.rid)">{{
            scope.row.姓名 || scope.row.候选人
          }}</a>
          <span v-else>{{ scope.row.姓名 || scope.row.候选人 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">{{
          scope.row.isFinal ? '终面' : scope.row.round ? `${scope.row.round}面` : title
        }}</template>
      </el-table-column>
      <el-table-column label="时间">
        <template slot-scope="scope">{{
          scope.row.面试时间 || scope.row.offer签订日期 || scope.row.到岗日期
        }}</template>
      </el-table-column>
      <el-table-column prop="公司" label="公司" />
      <el-table-column prop="部门" label="部门" />
      <el-table-column prop="目前职位" label="目前职位" />
      <el-table-column prop="手机" label="手机" />
      <el-table-column label="地域">
        <template slot-scope="scope">{{ scope.row.地域 && scope.row.地域.join(';') }}</template>
      </el-table-column>
      <el-table-column label="职能模块">
        <template slot-scope="scope">{{ scope.row.职能模块 && scope.row.职能模块.join(';') }}</template>
      </el-table-column>
      <el-table-column prop="顾问" label="顾问" />
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    data: { type: Array, default: undefined },
  },
  computed: {
    root() {
      return window.app.root
    },
  },
  methods: {
    showRadish(id) {
      if (!id) return
      window.open(`${window.frontend}/#/radish-detail-blank/${id}`, '_blank')
    },
  },
}
</script>

<style></style>
